export const CompontHeader = ({
  text,
  className = "",
}: {
  text: string;
  className?: string;
}) => {
  return (
    <div
      className={` 
      flex items-center gap-2 w-full justify-center ${className}`}
    >
      <div className="rounded bg-[#FAED04] h-[1px] w-8" />
      <p className="text-xl font-[Pacifico] text-[#FAED04]">{text}</p>
      <div className="rounded bg-[#FAED04] h-[1px] w-8" />
    </div>
  );
};
